import { IPaginatedStoreWithItems } from '@planning/stores/PaginatedStore'
import { AuthStore, HubContext, MessageBus, authStore as authStoreObject } from '@tom-ui/utils'
import _ from 'lodash'
import { ReactNode, createContext, useContext, useState } from 'react'
import { CarrierType, GetTruckAppointmentsQueryType } from './app/api'
import { setupInterceptors } from './app/http-client'
import {
  containerEventsFilterDelegate,
  containerEventsSortDelegate,
} from './components/ContainerHistoryLinkIconButton'
import { GetVesselVisitsQuery, getVesselVisitsQueryHandler } from './messages'
import { EventTypes } from './messages/eventsTypes'
import {
  GetBerthsQuery,
  GetCompaniesByIdsQuery,
  GetContainerByIdQuery,
  GetContainerEventsQuery,
  GetContainersByVisitIdQuery,
  GetDeliveryOrdersQuery,
  GetExternalDriversQuery,
  GetNnrOrderByIdQuery,
  GetNnrOrdersByVisitIdQuery,
  GetNnrOrdersByVisitIdsQuery,
  GetNnrOrdersQuery,
  GetOrderByIdQuery,
  GetOrdersByIdsQuery,
  GetOrdersByReferenceNumberQuery,
  GetOrdersByVisitIdQuery,
  GetRailTracksQuery,
  GetTenantQuery,
  GetTruckVisitsByIdsQuery,
  GetTruckVisitsQuery,
  GetTrucksQuery,
  GetVesselServicesQuery,
  GetVesselVisitByIdQuery,
  GetVesselVisitsByIdsQuery,
  GetVesselsByIdsQuery,
  GetVesselsQuery,
  getBerthsQueryHandler,
  getCompaniesByIdsQueryHandler,
  getContainerByIdQueryHandler,
  getContainerEventsQueryHandler,
  getContainersByVisitIdQueryHandler,
  getDeliveryOrdersQueryHandler,
  getExternalDriversQueryHandler,
  getNnrOrderByIdQueryHandler,
  getNnrOrdersByVisitIdQueryHandler,
  getNnrOrdersByVisitIdsQueryHandler,
  getNnrOrdersQueryHandler,
  getOrderByIdQueryHandler,
  getOrdersByIdsQueryHandler,
  getOrdersByReferenceNumberQueryHandler,
  getOrdersByVisitIdQueryHandler,
  getRailTracksQueryHandler,
  getTenantQueryHandler,
  getTruckVisitsByIdsQueryHandler,
  getTruckVisitsQueryHandler,
  getTrucksQueryHandler,
  getVesselServicesQueryHandler,
  getVesselVisitByIdQueryHandler,
  getVesselVisitsByIdsQueryHandler,
  getVesselsByIdsQueryHandler,
  getVesselsQueryHandler,
} from './messages/queries'
import { GetIssuesQuery, getIssuesQueryHandler } from './messages/queries/getIssuesQueryHandler'
import {
  GetOrdersByContainerNumberQuery,
  getOrdersByContainerNumberQueryHandler,
} from './messages/queries/getOrdersByContainerNumberQueryHandler'
import {
  GetRailVisitByIdQuery,
  getRailVisitByIdQueryHandler,
} from './messages/queries/getRailVisitByIdQueryHandler'
import {
  GetRailVisitsByIdsQuery,
  getRailVisitsByIdsQueryHandler,
} from './messages/queries/getRailVisitsByIdsQueryHandler'
import {
  GetRailVisitsQuery,
  getRailVisitsQueryHandler,
} from './messages/queries/getRailVisitsQueryHandler'
import {
  GetRailcarTrackPositionsQuery,
  getRailcarTrackPositionsQueryHandler,
} from './messages/queries/getRailcarTrackPositionsQueryHandler'
import {
  GetRailcarsQuery,
  getRailcarsQueryHandler,
} from './messages/queries/getRailcarsQueryHandler'
import {
  GetReleaseOrdersQuery,
  getReleaseOrdersQueryHandler,
} from './messages/queries/getReleaseOrdersQueryHandler'
import {
  deliveryOrdersFilterDelegate,
  deliveryOrdersSortingDelegate,
} from './pages/DeliveryOrders/DeliveryOrderPage'
import { IssueItemStore } from './pages/Issues/Stores/IssueItemStore'
// import { IssuesViewStore } from './pages/Issues/Stores/IssuesViewStore'

import {
  GetCompanyByIdQuery,
  getCompanyByIdQueryHandlerHandler,
} from './messages/queries/getCompanyByIdQueryHandler'
import {
  GetContainerJourneysQuery,
  getContainerJourneysQueryHandler,
} from './messages/queries/getContainerJourneysQueryHandler'
import {
  GetContainersByIdsQuery,
  getContainersByIdsQueryHandler,
} from './messages/queries/getContainersByIdsQueryHandler'
import {
  GetExternalDriversByIdsQuery,
  getExternalDriversByIdsQueryHandler,
} from './messages/queries/getExternalDriversByIdsQueryHandler'
import { GetHoldsQuery, getHoldsQueryHandler } from './messages/queries/getHoldsQueryHandler'
import {
  GetNumericReleaseByIdQuery,
  getNumericReleaseByIdQueryHandler,
} from './messages/queries/getNumericReleaseByIdQueryHandler'
import {
  GetNumericReleasesQuery,
  getNumericReleasesQueryHandler,
} from './messages/queries/getNumericReleasesQueryHandler'
import {
  GetOrdersByNnrOrderIdsQuery,
  getOrdersByNnrOrderIdsQueryHandler,
} from './messages/queries/getOrdersByNnrOrderIdsQueryHandler'
import { GetRestowsQuery, GetRestowsQueryHandler } from './messages/queries/getRestowsQueryHandler'
import {
  GetUnreadUpdatesByOrderIdsQuery,
  getUnreadUpdatesByOrderIdsQueryHandler,
} from './messages/queries/getUnreadUpdatesByOrderIdsQueryHandler'
import {
  GetWeightClassesQuery,
  getWeightClassesQueryHandler,
} from './messages/queries/getWeightClassesQueryHandler'
import { GetGatesQuery, getGatesQueryHandler } from './messages/queries/getGatesQueryHandler'
import { ExternalDriverViewStore } from './pages/ExternalDriver/Stores/ExternalDriverViewStore'
import { ContainerJourneyItemStore } from './pages/Issues/Stores/ContainerJourneyItemStore'
import { ContainerAutocompleteStore } from './pages/Order/stores/ContainerAutocompleteStore'
import { IsoCodeMappingInputStore } from './pages/Order/stores/IsoCodeMappingInputStore'
import { OrderListStore } from './pages/Order/stores/OrderListStore'
import { OrderListUploadViewStoreV2 } from './pages/Order/stores/OrderListUploadViewStoreV2'
import { OrderListViewStore } from './pages/Order/stores/OrderListViewStore'
import { SelectOrderViewStore } from './pages/Order/stores/SelectOrderViewStore'
import {
  releaseOrdersFilterDelegate,
  releaseOrdersSortingDelegate,
} from './pages/ReleaseOrders/ReleaseOrdersPage'
import { ContainerJourneyReportDataStore } from './pages/Reports/ContainerJourneyReport/stores/ContainerJourneyReportDataStore'
import { ContainerJourneyReportViewStore } from './pages/Reports/ContainerJourneyReport/stores/ContainerJourneyReportViewStore'
import { ContainerJourneyDataStore } from './pages/ServiceOrders/Stores/ContainerJourneyDataStore'
import { ServiceOrdersListViewStore } from './pages/ServiceOrders/Stores/ServiceOrdersListViewStore'
import { ServiceOrdersViewStore } from './pages/ServiceOrders/Stores/ServiceOrdersViewStore'
import { vesselsFilterDelegate, vesselsSortingDelegate } from './pages/Vessel/VesselPage'
import {
  vesselVisitFilterDelegate,
  vesselVisitSortingDelegate,
} from './pages/VesselVisit/Components/CarrierVisitDashboard'
import { DataManager } from './rt-stores/DataManager'
import { BerthItemStore } from './rt-stores/berth/BerthItemStore'
import { PierItemStore } from './rt-stores/berth/PierItemStore'
import { IContainerEventItem } from './rt-stores/container/ContainerEventItem'
import { ContainerEventItemStore } from './rt-stores/container/ContainerEventItemStore'
import { ContainerItemStore } from './rt-stores/container/ContainerItemStore'
import { CompanyItemStore } from './rt-stores/externalDriver/CompanyItemStore'
import { ExternalDriverItemStore } from './rt-stores/externalDriver/ExternalDriverItemStore'
import { GateClerkTruckVisitEditStore } from './rt-stores/gateClerk/GateClerkTruckVisitEditStore'
import { HoldItemStore } from './rt-stores/hold/HoldItemStore'
import { NnrOrderItemStore } from './rt-stores/nnrOrder/NnrOrderItemStore'
import { NumericReleaseItemStore } from './rt-stores/numericRelease/NumericReleaseItemStore'
import { IOrderItem } from './rt-stores/order/OrderItem'
import { OrderItemStore } from './rt-stores/order/OrderItemStore'
import { OrderUpdateItemStore } from './rt-stores/orderUpdate/OrderUpdateItemStore'
import { RailTrackItemStore } from './rt-stores/railTrack/RailTrackItemStore'
import { RailcarTrackPositionItemStore } from './rt-stores/railTrack/RailcarTrackPositionItemStore'
import { IRailVisitItem } from './rt-stores/railVisit/RailVisitItem'
import { RailVisitItemStore } from './rt-stores/railVisit/RailVisitItemStore'
import { RailVisitPlanningStore } from './rt-stores/railVisit/RailVisitPlanningStore'
import { RailcarItemStore } from './rt-stores/railcar/RailcarItemStore'
import { IReleaseOrderItem } from './rt-stores/releaseOrder/ReleaseOrderItem'
import { ReleaseOrderItemStore } from './rt-stores/releaseOrder/ReleaseOrderItemStore'
import { RestowItemStore } from './rt-stores/restow/RestowItemStore'
import { TallymanV2ViewStore } from './rt-stores/tallyman/TallymanV2ViewStore'
import { TenantStore } from './rt-stores/tenant/TenantStore'
import { TruckItemStore } from './rt-stores/truck/TruckItemStore'
import { TruckVisitAggregationStore } from './rt-stores/truckVisit/TruckVisitAggregationStore'
import { TruckVisitItemStore } from './rt-stores/truckVisit/TruckVisitItemStore'
import { IVesselItem } from './rt-stores/vessel/VesselItem'
import { VesselItemStore } from './rt-stores/vessel/VesselItemStore'
import { VesselServiceItemStore } from './rt-stores/vesselService/VesselServiceItemStore'
import { IVesselVisitItem } from './rt-stores/vesselVisit/VesselVisitItem'
import { VesselVisitItemStore } from './rt-stores/vesselVisit/VesselVisitItemStore'
import { VesselVisitPlanningStore } from './rt-stores/vesselVisit/VesselVisitPlanningStore'
import { VisitTableViewStore } from './rt-stores/visit/VisitTableViewStore'
import {
  VisitItem,
  VisitViewStore,
  visitFilterDelegate,
  visitSortingDelegate,
} from './rt-stores/visit/VisitViewStore'
import { WeightClassItemStore } from './rt-stores/weightClass/WeightClassItemStore'
import { GateItemStore } from './rt-stores/gate/GateItemStore'
import { EntityQueryService } from './services/EntityQueryService'
import { AppViewStore } from './stores/AppViewStore'
import { DialogStore } from './stores/DialogStore'
import { DrawerStore } from './stores/DrawerStore'
import { LocalDataStoreWrapper, PaginatedLocalStore } from './stores/PaginatedLocalStore'
import { ContainerDamageReportViewStore } from './stores/damageReport/ContainerDamageReportViewStore'
import {
  DangerousGoodsDefinitionDataStore,
  createDangerousGoodsDefinitionDataStore,
} from './stores/dangerousGoodsDefinition/DangerousGoodsDefinitionDataStore'
import { DangerousGoodsDefinitionTableViewStore } from './stores/dangerousGoodsDefinition/DangerousGoodsDefinitionTableViewStore'
import { GateClerkViewStore, IGateClerkViewStore } from './stores/gateClerk/GateClerkViewStore'
import { GateInViewStore } from './stores/gateControl/GateInViewStore'
import { GateSessionStore } from './stores/gateControl/GateSessionStore'
import { GeneralCargoViewStore } from './stores/generalCargo/GeneralCargoViewStore'
import { ReportIssueViewStore } from './stores/issues/ReportIssueViewStore'
import { NNROrderViewStore, createNNROrderViewStore } from './stores/order/NNROrderViewStore'
import {
  TruckAppointmentOrderStore,
  createTruckAppointmentOrderViewStore,
} from './stores/truckAppointment/TruckAppointmentOrderViewStore'
import {
  TruckAppointmentViewStore,
  createTruckAppointmentViewStore,
} from './stores/truckAppointment/TruckAppointmentViewStore'
import { FormDialogUtilStore } from './stores/utils/FormDialogUtilStore'

type IStore = {
  authStore: AuthStore
  gateClerkTruckVisitEditStore: GateClerkTruckVisitEditStore
  tallymanSelectVesselAndOperationViewStore: TallymanV2ViewStore
  truckVisitQueryService: EntityQueryService
  vesselVisitQueryService: EntityQueryService
  railVisitQueryService: EntityQueryService
  tenantStore: TenantStore
  truckVisitAggregationStore: TruckVisitAggregationStore
}

type IItemStore = {
  pierItemStore: PierItemStore
  berthItemStore: BerthItemStore
  holdItemStore: HoldItemStore
  containerItemStore: ContainerItemStore
  containerEventItemStore: ContainerEventItemStore
  numericReleaseItemStore: NumericReleaseItemStore
  nnrOrderItemStore: NnrOrderItemStore
  orderItemStore: OrderItemStore
  truckItemStore: TruckItemStore
  truckVisitItemStore: TruckVisitItemStore
  vesselItemStore: VesselItemStore
  vesselVisitItemStore: VesselVisitItemStore
  railcarItemStore: RailcarItemStore
  railVisitItemStore: RailVisitItemStore
  railTrackItemStore: RailTrackItemStore
  railcarTrackPositionItemStore: RailcarTrackPositionItemStore
  issueItemStore: IssueItemStore
  orderUpdateItemStore: OrderUpdateItemStore
  restowItemStore: RestowItemStore
  containerJourneyItemStore: ContainerJourneyItemStore
  externalDriverItemStore: ExternalDriverItemStore
  vesselServiceItemStore: VesselServiceItemStore
  companyItemStore: CompanyItemStore
  weightClassItemStore: WeightClassItemStore
  gateItemStore: GateItemStore
}

type IViewStore = {
  containerAutocompleteStore: ContainerAutocompleteStore
  containerEventViewStore: IPaginatedStoreWithItems<IContainerEventItem>
  deliveryOrderViewStore: IPaginatedStoreWithItems<IOrderItem>
  gateClerkNnrOrderViewStore: NNROrderViewStore
  orderListStore: OrderListStore
  orderListUploadViewStoreV2: OrderListUploadViewStoreV2
  releaseOrderViewStore: IPaginatedStoreWithItems<IReleaseOrderItem>
  truckAppointmentOrderStore: TruckAppointmentOrderStore
  truckAppointmentViewStore: TruckAppointmentViewStore
  vesselViewStore: IPaginatedStoreWithItems<IVesselItem>
  vesselVisitListViewStore: IPaginatedStoreWithItems<IVesselVisitItem>
  railVisitListViewStore: IPaginatedStoreWithItems<IRailVisitItem>
  vesselVisitPlanningStore: VesselVisitPlanningStore
  visitViewStore: VisitViewStore
  visitListViewStore: IPaginatedStoreWithItems<VisitItem>
  visitTableViewStore: VisitTableViewStore
  gateClerkViewStore: IGateClerkViewStore
  selectOrderViewStore: SelectOrderViewStore
  gateInViewStore: GateInViewStore
  gateSessionStore: GateSessionStore
  generalCargoViewStore: GeneralCargoViewStore
  serviceOrdersViewStore: ServiceOrdersViewStore
  serviceOrdersListViewStore: ServiceOrdersListViewStore
  formDialogUtilStore: FormDialogUtilStore
  dangerousGoodsDefinitionDataStore: DangerousGoodsDefinitionDataStore
  dangerousGoodsDefinitionTableViewStore: DangerousGoodsDefinitionTableViewStore
  containerDamageReportViewStore: ContainerDamageReportViewStore
  railVisitPlanningStore: RailVisitPlanningStore
  containerJourneyDataStore: ContainerJourneyDataStore
  // issuesViewStore: IssuesViewStore
  isoCodeMappingInputStore: IsoCodeMappingInputStore
  reportIssueViewStore: ReportIssueViewStore
  orderListViewStore: OrderListViewStore
  externalDriverViewStore: ExternalDriverViewStore
  containerJourneyReportViewStore: ContainerJourneyReportViewStore
}

export const messageBus = new MessageBus()

export interface IAppStore extends IStore, IItemStore, IViewStore {
  appViewStore: AppViewStore
  drawerStore: DrawerStore
  dialogStore: DialogStore
}

const createPlanningStores = () => {
  const authStore = authStoreObject

  messageBus.subscribeQuery(GetBerthsQuery.type, getBerthsQueryHandler)
  messageBus.subscribeQuery(GetCompaniesByIdsQuery.type, getCompaniesByIdsQueryHandler)
  messageBus.subscribeQuery(GetCompanyByIdQuery.type, getCompanyByIdQueryHandlerHandler)
  messageBus.subscribeQuery(GetContainerByIdQuery.type, getContainerByIdQueryHandler)
  messageBus.subscribeQuery(GetContainersByIdsQuery.type, getContainersByIdsQueryHandler)
  messageBus.subscribeQuery(GetContainerJourneysQuery.type, getContainerJourneysQueryHandler)
  messageBus.subscribeQuery(GetContainerEventsQuery.type, getContainerEventsQueryHandler)
  messageBus.subscribeQuery(GetContainersByVisitIdQuery.type, getContainersByVisitIdQueryHandler)
  messageBus.subscribeQuery(GetDeliveryOrdersQuery.type, getDeliveryOrdersQueryHandler)
  messageBus.subscribeQuery(GetNnrOrderByIdQuery.type, getNnrOrderByIdQueryHandler)
  messageBus.subscribeQuery(GetNnrOrdersByVisitIdQuery.type, getNnrOrdersByVisitIdQueryHandler)
  messageBus.subscribeQuery(GetNnrOrdersByVisitIdsQuery.type, getNnrOrdersByVisitIdsQueryHandler)
  messageBus.subscribeQuery(GetNumericReleasesQuery.type, getNumericReleasesQueryHandler)
  messageBus.subscribeQuery(GetNumericReleaseByIdQuery.type, getNumericReleaseByIdQueryHandler)
  messageBus.subscribeQuery(GetNnrOrdersQuery.type, getNnrOrdersQueryHandler)
  messageBus.subscribeQuery(GetOrderByIdQuery.type, getOrderByIdQueryHandler)
  messageBus.subscribeQuery(GetOrdersByIdsQuery.type, getOrdersByIdsQueryHandler)
  messageBus.subscribeQuery(
    GetOrdersByContainerNumberQuery.type,
    getOrdersByContainerNumberQueryHandler,
  )
  messageBus.subscribeQuery(GetOrdersByNnrOrderIdsQuery.type, getOrdersByNnrOrderIdsQueryHandler)
  messageBus.subscribeQuery(GetOrdersByVisitIdQuery.type, getOrdersByVisitIdQueryHandler)
  messageBus.subscribeQuery(
    GetOrdersByReferenceNumberQuery.type,
    getOrdersByReferenceNumberQueryHandler,
  )
  messageBus.subscribeQuery(GetReleaseOrdersQuery.type, getReleaseOrdersQueryHandler)
  messageBus.subscribeQuery(GetTenantQuery.type, getTenantQueryHandler)
  messageBus.subscribeQuery(GetTrucksQuery.type, getTrucksQueryHandler)
  messageBus.subscribeQuery(GetTruckVisitsByIdsQuery.type, getTruckVisitsByIdsQueryHandler)
  messageBus.subscribeQuery(GetTruckVisitsQuery.type, getTruckVisitsQueryHandler)
  messageBus.subscribeQuery(GetVesselsByIdsQuery.type, getVesselsByIdsQueryHandler)
  messageBus.subscribeQuery(GetVesselsQuery.type, getVesselsQueryHandler)
  messageBus.subscribeQuery(GetVesselVisitByIdQuery.type, getVesselVisitByIdQueryHandler)
  messageBus.subscribeQuery(GetVesselVisitsByIdsQuery.type, getVesselVisitsByIdsQueryHandler)
  messageBus.subscribeQuery(GetVesselVisitsQuery.type, getVesselVisitsQueryHandler)
  messageBus.subscribeQuery(GetRailVisitsQuery.type, getRailVisitsQueryHandler)
  messageBus.subscribeQuery(GetRailVisitByIdQuery.type, getRailVisitByIdQueryHandler)
  messageBus.subscribeQuery(GetRailVisitsByIdsQuery.type, getRailVisitsByIdsQueryHandler)
  messageBus.subscribeQuery(GetRailTracksQuery.type, getRailTracksQueryHandler)
  messageBus.subscribeQuery(
    GetRailcarTrackPositionsQuery.type,
    getRailcarTrackPositionsQueryHandler,
  )
  messageBus.subscribeQuery(GetRailcarsQuery.type, getRailcarsQueryHandler)
  messageBus.subscribeQuery(GetIssuesQuery.type, getIssuesQueryHandler)
  messageBus.subscribeQuery(GetHoldsQuery.type, getHoldsQueryHandler)
  messageBus.subscribeQuery(
    GetUnreadUpdatesByOrderIdsQuery.type,
    getUnreadUpdatesByOrderIdsQueryHandler,
  )
  messageBus.subscribeQuery(GetRestowsQuery.type, GetRestowsQueryHandler)
  messageBus.subscribeQuery(GetVesselServicesQuery.type, getVesselServicesQueryHandler)
  messageBus.subscribeQuery(GetExternalDriversQuery.type, getExternalDriversQueryHandler)
  messageBus.subscribeQuery(GetExternalDriversByIdsQuery.type, getExternalDriversByIdsQueryHandler)
  messageBus.subscribeQuery(GetWeightClassesQuery.type, getWeightClassesQueryHandler)
  messageBus.subscribeQuery(GetGatesQuery.type, getGatesQueryHandler)

  const hubContext = new HubContext('/planningHub', messageBus)
  const listenedEvents: string[] = [
    EventTypes.BerthUpsertedEvent,
    EventTypes.BerthDeletedEvent,
    EventTypes.ContainerEventsUpsertedEvent,
    EventTypes.ContainerUpsertedEvent,
    EventTypes.FeatureFlagDeleted,
    EventTypes.FeatureFlagUpserted,
    EventTypes.NonNumericOrderUpsertedEvent,
    EventTypes.NonNumericOrderDeletedEvent,
    EventTypes.OrdersDeletedEvent,
    EventTypes.OrdersUpsertedEvent,
    EventTypes.ReleaseOrdersUpsertedEvent,
    EventTypes.TenantUpsertedEvent,
    EventTypes.TruckDeletedEvent,
    EventTypes.TruckUpsertedEvent,
    EventTypes.TruckVisitUpsertedEvent,
    EventTypes.TruckVisitDeletedEvent,
    EventTypes.VesselDeletedEvent,
    EventTypes.VesselUpsertedEvent,
    EventTypes.VesselVisitCreated,
    EventTypes.CarrierVisitDeleted,
    EventTypes.VesselVisitUpdated,
    EventTypes.CarrierVisitConflictUpdated,
    EventTypes.RailVisitCreated,
    EventTypes.RailVisitUpdated,
    EventTypes.RailVisitDeleted,
    EventTypes.PackageUpserted,
    EventTypes.PackageDeleted,
    EventTypes.RailTrackUpsertedEvent,
    EventTypes.RailTrackDeletedEvent,
    EventTypes.RailcarTrackPositionUpsertedEvent,
    EventTypes.RailcarTrackPositionDeletedEvent,
    EventTypes.RailcarUpsertedEvent,
    EventTypes.RailcarDeletedEvent,
    EventTypes.IssueUpsertedEvent,
    EventTypes.ContainerJourneysUpsertedEvent,
    EventTypes.OrderUpdatesUpsertedEvent,
    EventTypes.NumericReleaseUpsertedEvent,
    EventTypes.NumericReleasesDeletedEvent,
    EventTypes.RemainOnBoardUnitsUpsertedEvent,
    EventTypes.RemainOnBoardUnitsDeletedEvent,
    EventTypes.VesselServiceUpsertedInternalEvent,
    EventTypes.VesselServiceDeletedInternalEvent,
    EventTypes.ExternalDriverUpsertedInternalEvent,
    EventTypes.ExternalDriverDeletedInternalEvent,
    EventTypes.WeightClassUpsertedInternalEvent,
    EventTypes.WeightClassDeletedInternalEvent,
    EventTypes.CompanyUpsertedInternalEvent,
    EventTypes.HoldUpsertedInternalEvent,
    EventTypes.GateUpsertedEvent,
    EventTypes.GateDeletedEvent,
  ]
  listenedEvents.forEach(c => hubContext.registerPassThroughConnection(c))
  hubContext.startConnection()

  const gateClerkNnrOrderViewStore = createNNROrderViewStore(CarrierType.Truck)
  const truckAppointmentViewStore = createTruckAppointmentViewStore(
    GetTruckAppointmentsQueryType.All,
  )
  const truckAppointmentOrderStore = createTruckAppointmentOrderViewStore(truckAppointmentViewStore)

  const vesselItemStore = new VesselItemStore(messageBus)

  const truckItemStore = new TruckItemStore(messageBus)

  const railcarItemStore = new RailcarItemStore(messageBus)

  const weightClassItemStore = new WeightClassItemStore(messageBus)
  const gateItemStore = new GateItemStore(messageBus)

  const gateClerkTruckVisitEditStore = new GateClerkTruckVisitEditStore(truckAppointmentOrderStore)

  const vesselVisitItemStore = new VesselVisitItemStore(messageBus)
  const railTrackItemStore = new RailTrackItemStore(messageBus)
  const railcarTrackPositionItemStore = new RailcarTrackPositionItemStore(
    messageBus,
    railTrackItemStore,
    railcarItemStore,
  )
  const railVisitItemStore = new RailVisitItemStore(
    messageBus,
    railTrackItemStore,
    railcarTrackPositionItemStore,
  )
  const visitViewStore = new VisitViewStore()

  const containerJourneyDataStore = new ContainerJourneyDataStore(messageBus)
  const containerItemStore = new ContainerItemStore(messageBus)
  const containerEventItemStore = new ContainerEventItemStore(messageBus)

  const truckVisitItemStore = new TruckVisitItemStore(messageBus)
  const orderUpdateItemStore = new OrderUpdateItemStore(messageBus)
  const containerJourneyItemStore = new ContainerJourneyItemStore(messageBus, containerItemStore)
  const holdItemStore = new HoldItemStore(messageBus, containerJourneyItemStore, containerItemStore)
  containerJourneyItemStore.connectHoldStore(holdItemStore)

  const issueItemStore = new IssueItemStore(
    messageBus,
    containerJourneyItemStore,
    containerItemStore,
  )

  const companyItemStore = new CompanyItemStore(messageBus)

  const orderItemStore = new OrderItemStore(
    messageBus,
    railcarTrackPositionItemStore,
    issueItemStore,
    orderUpdateItemStore,
    containerJourneyItemStore,
    companyItemStore,
    weightClassItemStore,
  )

  const pierItemStore = new PierItemStore()
  const berthItemStore = new BerthItemStore(messageBus, pierItemStore)
  const restowItemStore = new RestowItemStore(messageBus)
  const externalDriverItemStore = new ExternalDriverItemStore(messageBus)
  const truckVisitAggregationStore = new TruckVisitAggregationStore(
    truckVisitItemStore,
    orderItemStore,
    containerItemStore,
    containerJourneyItemStore,
  )

  const orderListUploadViewStoreV2 = new OrderListUploadViewStoreV2(
    orderItemStore,
    vesselVisitItemStore,
    railVisitItemStore,
    railTrackItemStore,
    railcarTrackPositionItemStore,
    companyItemStore,
  )

  const formDialogUtilStore = new FormDialogUtilStore()

  const dangerousGoodsDefinitionDataStore = createDangerousGoodsDefinitionDataStore()

  const dangerousGoodsDefinitionTableViewStore = new DangerousGoodsDefinitionTableViewStore(
    dangerousGoodsDefinitionDataStore,
    formDialogUtilStore,
  )

  containerJourneyItemStore.connect(orderItemStore)
  containerJourneyItemStore.connectHoldItemStore(holdItemStore)

  railVisitItemStore.connect(orderItemStore)

  vesselVisitItemStore.connect(
    vesselItemStore,
    berthItemStore,
    orderItemStore,
    restowItemStore,
    companyItemStore,
  )

  truckVisitItemStore.connect(
    orderItemStore,
    truckItemStore,
    externalDriverItemStore,
    companyItemStore,
    gateItemStore,
  )

  orderItemStore.connect(
    vesselVisitItemStore,
    railVisitItemStore,
    truckVisitItemStore,
    containerItemStore,
    railTrackItemStore,
    weightClassItemStore,
    containerJourneyItemStore,
  )

  const tallymanSelectVesselAndOperationViewStore = new TallymanV2ViewStore(
    railVisitItemStore,
    vesselVisitItemStore,
  )

  const numericReleaseItemStore = new NumericReleaseItemStore(
    messageBus,
    orderItemStore,
    companyItemStore,
    vesselVisitItemStore,
    railVisitItemStore,
  )

  const nnrOrderItemStore = new NnrOrderItemStore(
    messageBus,
    companyItemStore,
    vesselVisitItemStore,
    railVisitItemStore,
  )
  nnrOrderItemStore.connect(orderItemStore)

  const tenantStore = new TenantStore(messageBus)

  new DataManager(
    vesselVisitItemStore,
    railVisitItemStore,
    vesselItemStore,
    berthItemStore,
    railTrackItemStore,
    railcarTrackPositionItemStore,
    orderItemStore,
    truckVisitItemStore,
    truckItemStore,
    containerItemStore,
    nnrOrderItemStore,
    issueItemStore,
    orderUpdateItemStore,
    containerJourneyItemStore,
    externalDriverItemStore,
    companyItemStore,
  )

  const vesselVisitQueryService = new EntityQueryService(
    messageBus,
    range => new GetVesselVisitsQuery(range.from, range.to),
    id => new GetVesselVisitByIdQuery(id),
  )

  const truckVisitQueryService = new EntityQueryService(
    messageBus,
    range => new GetTruckVisitsQuery(range.from, range.to),
  )

  const railVisitQueryService = new EntityQueryService(
    messageBus,
    range => new GetRailVisitsQuery(range.from, range.to, true),
    id => new GetRailVisitByIdQuery(id),
  )

  const vesselVisitListViewStore = new PaginatedLocalStore<IVesselVisitItem>(
    new LocalDataStoreWrapper(
      () => _.values(vesselVisitItemStore.elements),
      query => vesselVisitQueryService.fetch(query),
    ),
    vesselVisitSortingDelegate,
    vesselVisitFilterDelegate,
  )

  const railVisitListViewStore = new PaginatedLocalStore<IRailVisitItem>(
    new LocalDataStoreWrapper(
      () => _.values(railVisitItemStore.elements),
      query => railVisitQueryService.fetch(query),
    ),
  )

  const visitListViewStore = new PaginatedLocalStore<VisitItem>(
    new LocalDataStoreWrapper(
      () => _.values(visitViewStore.elements),
      async query => {
        await vesselVisitQueryService.fetch(query)
        await railVisitQueryService.fetch(query)
        return Promise.resolve()
      },
    ),
    visitSortingDelegate,
    visitFilterDelegate,
  )

  const vesselVisitPlanningStore = new VesselVisitPlanningStore()

  const railVisitPlanningStore = new RailVisitPlanningStore()

  const visitTableViewStore = new VisitTableViewStore(visitListViewStore)

  const gateClerkViewStore = new GateClerkViewStore(tenantStore, holdItemStore)

  const gateInViewStore = new GateInViewStore(holdItemStore)
  const gateSessionStore = new GateSessionStore(gateItemStore)

  const generalCargoViewStore = new GeneralCargoViewStore(
    messageBus,
    vesselVisitItemStore,
    truckVisitItemStore,
    railVisitItemStore,
    companyItemStore,
  )

  const selectOrderViewStore = new SelectOrderViewStore(orderItemStore, containerJourneyDataStore)
  const serviceOrdersViewStore = new ServiceOrdersViewStore(messageBus, containerJourneyDataStore)
  const serviceOrdersListViewStore = new ServiceOrdersListViewStore(containerJourneyDataStore)
  // const issuesViewStore = new IssuesViewStore(issueItemStore, containerJourneyDataStore)
  const containerDamageReportViewStore = new ContainerDamageReportViewStore()
  const isoCodeMappingInputStore = new IsoCodeMappingInputStore()
  const reportIssueViewStore = new ReportIssueViewStore()
  const orderListViewStore = new OrderListViewStore(orderItemStore)

  let loadedDeliveryOrders = false
  const deliveryOrderViewStore = new PaginatedLocalStore<IOrderItem>(
    new LocalDataStoreWrapper(
      () => _.values(orderItemStore.deliveryOrders),
      async () => {
        if (loadedDeliveryOrders) {
          return
        }
        messageBus.dispatchQuery(new GetDeliveryOrdersQuery(undefined, undefined, true))
        loadedDeliveryOrders = true
      },
    ),
    deliveryOrdersSortingDelegate,
    deliveryOrdersFilterDelegate,
  )

  const releaseOrderItemStore = new ReleaseOrderItemStore(messageBus)
  let loadedReleaseOrders = false
  const releaseOrderViewStore = new PaginatedLocalStore<IReleaseOrderItem>(
    new LocalDataStoreWrapper(
      () => _.values(releaseOrderItemStore.elements),
      async () => {
        if (loadedReleaseOrders) {
          return
        }
        messageBus.dispatchQuery(new GetReleaseOrdersQuery(1, 1000, undefined, undefined, true))
        loadedReleaseOrders = true
      },
    ),
    releaseOrdersSortingDelegate,
    releaseOrdersFilterDelegate,
  )

  const containerAutocompleteStore = new ContainerAutocompleteStore()

  const orderListStore = new OrderListStore(orderItemStore, vesselItemStore, truckItemStore)

  let loadedVessels = false
  const vesselViewStore = new PaginatedLocalStore<IVesselItem>(
    new LocalDataStoreWrapper(
      () => _.values(vesselItemStore.elements),
      async () => {
        if (loadedVessels) {
          return
        }
        messageBus.dispatchQuery(new GetVesselsQuery(1, 10000))
        loadedVessels = true
      },
    ),
    vesselsSortingDelegate,
    vesselsFilterDelegate,
  )

  const containerEventViewStore = new PaginatedLocalStore<IContainerEventItem>(
    new LocalDataStoreWrapper(
      () => _.values(containerEventItemStore.containerEventsByContainerNumber),
      undefined,
    ),
    containerEventsSortDelegate,
    containerEventsFilterDelegate,
  )

  const vesselServiceItemStore = new VesselServiceItemStore(messageBus)

  const appViewStore = new AppViewStore()
  const drawerStore = new DrawerStore()
  const dialogStore = new DialogStore()

  const externalDriverViewStore = new ExternalDriverViewStore(externalDriverItemStore)

  const containerJourneyReportDataStore = new ContainerJourneyReportDataStore()
  const containerJourneyReportViewStore = new ContainerJourneyReportViewStore(
    containerJourneyReportDataStore,
  )

  const store: IAppStore = {
    appViewStore,
    authStore,
    pierItemStore,
    berthItemStore,
    containerAutocompleteStore,
    containerEventItemStore,
    containerEventViewStore,
    containerItemStore,
    deliveryOrderViewStore,
    drawerStore,
    dialogStore,
    gateClerkNnrOrderViewStore,
    gateClerkTruckVisitEditStore,
    numericReleaseItemStore,
    nnrOrderItemStore,
    orderItemStore,
    orderListStore,
    orderListUploadViewStoreV2,
    releaseOrderViewStore,
    tallymanSelectVesselAndOperationViewStore,
    truckAppointmentOrderStore,
    truckAppointmentViewStore,
    truckItemStore,
    truckVisitItemStore,
    truckVisitQueryService,
    vesselItemStore,
    vesselViewStore,
    vesselVisitItemStore,
    vesselVisitListViewStore,
    vesselVisitPlanningStore,
    railVisitQueryService,
    railVisitItemStore,
    companyItemStore,
    railVisitListViewStore,
    railTrackItemStore,
    railcarItemStore,
    visitViewStore,
    visitListViewStore,
    visitTableViewStore,
    gateClerkViewStore,
    selectOrderViewStore,
    vesselVisitQueryService,
    tenantStore,
    gateInViewStore,
    gateSessionStore,
    generalCargoViewStore,
    serviceOrdersViewStore,
    serviceOrdersListViewStore,
    formDialogUtilStore,
    dangerousGoodsDefinitionDataStore,
    dangerousGoodsDefinitionTableViewStore,
    containerDamageReportViewStore,
    railVisitPlanningStore,
    railcarTrackPositionItemStore,
    containerJourneyDataStore,
    // issuesViewStore,
    issueItemStore,
    isoCodeMappingInputStore,
    reportIssueViewStore,
    externalDriverViewStore,
    containerJourneyReportViewStore,
    orderListViewStore,
    orderUpdateItemStore,
    restowItemStore,
    containerJourneyItemStore,
    externalDriverItemStore,
    truckVisitAggregationStore,
    vesselServiceItemStore,
    weightClassItemStore,
    gateItemStore,
    holdItemStore,
  }
  setupInterceptors(appViewStore)

  return store
}

export const PlanningContext = createContext<IAppStore>(null as any)

export const PlanningStoreProvider = ({ children }: { children: ReactNode }) => {
  const [store] = useState(createPlanningStores())
  return <PlanningContext.Provider value={store}>{children}</PlanningContext.Provider>
}

export const usePlanningStore = () => useContext(PlanningContext)
